jQuery(document).ready(function($) {
    var windowWidth = $(window).width();
    
/* ====================== MOBILE NAV ======================  */
    $('.menu-toggle').on("click", function() {
        $('.burger-toggle-nav nav').removeClass('sub-menu-open');
        $('.main-nav .menu-item-has-children').removeClass('open');
        $('.main-nav .menu-item-has-children .sub-menu').removeClass('open');
    });

	$(window).on('click',function(event){
		if($('.menu-toggle').hasClass('active')) {
			if(event.target != $('.burger-toggle-nav nav')[0] && event.target != $('.menu-toggle')[0] && event.target != $('.menu-toggle span')[0] && event.target != $('header .back')[0]) {
				console.log('in here');
				$('.menu-toggle').removeClass('active');
		        $('header .burger-toggle-nav nav').removeClass('open');
		        $('header').removeClass('open');
		        $('.behind-nav-bg').removeClass('open');
		        $('body').removeClass('noscroll');
		       	lenis.start();
		       	$('.burger-toggle-nav nav').removeClass('sub-menu-open');
				$('body').removeClass('noscroll');
        		$('.main-nav .menu-item-has-children').removeClass('open');
        		$('.main-nav .menu-item-has-children .sub-menu').removeClass('open');
			}
		}
	});

    //if(windowWidth < 1023) {
        $('.main-nav .menu-item-has-children').on("click", function(e) {
            e.stopPropagation();
            $('nav').addClass('sub-menu-open');
            $('.main-nav .sub-menu').removeClass('open');
            $('.main-nav .menu-item-has-children').removeClass('open');
            $(this).addClass('open');
            $(this).find('.sub-menu').addClass('open');

        })

        $('.burger-toggle-nav nav .sub-menu a').on("click", function(event) {
            event.stopPropagation();
        });

        $('.burger-toggle-nav nav .back').on("click", function() {
            $('.burger-toggle-nav nav').removeClass('sub-menu-open');
            $('.main-nav .menu-item-has-children').removeClass('open');
            $('.main-nav .menu-item-has-children .sub-menu').removeClass('open');
        });

   //}

/* ====================== Accordion Scroll ======================  */
    $('.accordion .accordion-title').on('click', function () {
        var row = $(this);
        setTimeout(function(){
            $('html,body').animate({
                scrollTop: $(row).offset().top - 80
            });
        },250);
    });


/* ====================== Spaces Modal ======================  */
    var modal = document.getElementById("spaces-modal");
	var close = document.getElementsByClassName("spaces-close")[0];

	function closeModal() {
		modal.style.display = "none";
		$('body, html').removeClass('modal-open')
		$('#spaces-modal').removeClass('active');
		$('.modal-content').removeClass('active');
		$('.space-content').removeClass('active');
		$('.spaces-map .map-container').removeClass('noscroll');
 	}

 	if($(modal).length) {
		close.onclick = function() {
			closeModal()
		}
	}

	window.onclick = function(event) {
		if (event.target == modal) {
			closeModal()
		}
	}

	function initSwiper() {
		$('.space-content.active .swiper').each(function(index, swiperEl) {
			const $spaceContent = $(swiperEl).closest('.space-content.active');
			const $swiperNext = $spaceContent.find('.swiper-next');

			new Swiper(swiperEl, {
				slidesPerView: 1.2,
				loop: true,
				speed: 1000,
                spaceBetween: 20,
				fadeEffect: { crossFade: true },
				watchSlidesProgress: true,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
                navigation: {
                    nextEl: $swiperNext[0],
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1.1,
                        spaceBetween: 30,
                    },
                },
			});
		});
	}

    $('.spaces-map .space-marker-container').click(function(e){
        e.preventDefault();
        $('.select-options').removeClass('active');
        $('body, html').addClass('modal-open');

        $('.spaces-map .map-container').addClass('noscroll');

        var spaceID = $(this).attr('space-id');
        var modal = document.getElementById("spaces-modal");
        modal.style.display = "block";
        $(modal).addClass('active');
        $('.modal-content').addClass('active');
        $('.space-content[space-related="'+ spaceID +'"').addClass('active');
        initSwiper();
    });

/* ====================== Spaces Modal Carousel ======================  */
    $('.spaces-map .space-marker-container').click(function(e){        
        e.preventDefault();
        $('.select-options').removeClass('active');
        //$('body, html').addClass('modal-open');

        $('.spaces-map .map-container').addClass('noscroll');

        var spaceID = $(this).attr('space-id');
        var modal = document.getElementById("spaces-modal");
        modal.style.display = "block";
        $(modal).addClass('active');
        $('.modal-content').addClass('active');
        $('.space-content[space-related="'+ spaceID +'"').addClass('active');
        initSwiper();
    });
});

